import React from "react";

interface SubmitButtonProps {
  isSubmitting: boolean;
  label: string;
  loadingLabel?: string;
  className?: string;
}

const SubmitButton: React.FC<SubmitButtonProps> = ({
  isSubmitting,
  label,
  loadingLabel,
  className,
}) => (
  <button type="submit" disabled={isSubmitting} className={className}>
    {isSubmitting ? (loadingLabel ?? label) : label}
  </button>
);

export default SubmitButton;
